
import { EventEmitter, Injectable, Output } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { TagControllerModalComponent } from 'src/app/shared/modals/tag-controller-modal/tag-controller-modal.component';

@Injectable({
  providedIn: 'root'
})
export class TagControllerModalService {

  @Output() modelChanged = new EventEmitter<any>(); 

  constructor(  private modalService: NgbModal) { }

  openModal(model?: any) {
    var modalRef!: NgbModalRef;
    modalRef = this.modalService.open( TagControllerModalComponent, {windowClass : "customModalClassUnderName", size: 'lg', centered: false, backdrop: 'static', keyboard: false, scrollable: true });
    modalRef.componentInstance.model = model;
  
    modalRef.result.then(() => {
        this.modelChanged.emit(true);
        modalRef.componentInstance.ngOnDestroy();
      });
  }
}
